module.exports = __webpack_public_path__ + "img/star_line.5eabcd77.svg";